

var filaSeleccionada = undefined
export const pintarFilaSeleccionada = (row) => {
  //// resaltar fila
  if (filaSeleccionada !== undefined) {
    //var rowAnterior = document.getElementById("row-" +this.grupoSel.id)
    filaSeleccionada.classList.remove('table-pintar-fila')
  }
  filaSeleccionada = document.getElementById(row)
  filaSeleccionada.classList.add("table-pintar-fila");
};

var inputSeleccionado
export const habilitarInputSeleccionado = (row) => {

  var inputNuevoSeleccion = document.getElementById(row)
  if (inputNuevoSeleccion !== null) {

    if (inputSeleccionado !== undefined && inputSeleccionado !== inputNuevoSeleccion) {
      inputSeleccionado.disabled = true;
    }
    inputSeleccionado = inputNuevoSeleccion;
    inputNuevoSeleccion.disabled = false;
    inputNuevoSeleccion.focus();

  }
};

